export default{
    list: null,
    current_contact: {}
}